
import React from 'react';
import InvestmentLedger from '@/components/accounting/InvestmentLedger';

export const InvestmentTab = () => {
  return <InvestmentLedger />;
};
